import { AppDispatch, RootState } from "store/store";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setErrorMessageInactiveTenant } from "store/common/initialization/initialization-actions";
import { useTranslation } from "react-i18next";
import { getIsActiveTenantSet } from "store/environments/tenants/tenants-selectors";
import { getIsActiveEnvironmentSet } from "store/environments/environment-selectors";

const useInactiveTenant = (): void => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const isActiveEnvironment = useSelector((state: RootState) =>
        getIsActiveEnvironmentSet(state)
    );
    const isActiveTenant = useSelector((state: RootState) =>
        getIsActiveTenantSet(state)
    );

    useEffect(() => {
        dispatch(
            setErrorMessageInactiveTenant(
                !(isActiveEnvironment && isActiveTenant)
                    ? t("error.noActiveTenant")
                    : ""
            )
        );
    }, [isActiveEnvironment, isActiveTenant]);
};

export default useInactiveTenant;
